import {UIRouterReact, servicesPlugin, hashLocationPlugin, HookMatchCriteria} from '@uirouter/react';

import appStates from './app/states';

// Register the "requires auth" hook with the TransitionsService
import reqAuthHook from './global/requiresAuth.hook';

// Create a new instance of the Router
export const router = new UIRouterReact();
router.plugin(servicesPlugin);
router.plugin(hashLocationPlugin);

// Lazy load visualizer
// import('@uirouter/visualizer').then(module => router.plugin(module.Visualizer));

// Register the initial (eagerly loaded) states
appStates.forEach(state => router.stateRegistry.register(state));

// Global config for router
router.urlService.rules.initial({ state: 'app' });

router.transitionService.onBefore(reqAuthHook.criteria as HookMatchCriteria, reqAuthHook.callback, {priority: 10});
